export const getPreviousItem = (instance, itemId) => {
  const node = instance.getNode(itemId);
  const siblings = instance.getNavigableChildrenIds(node.parentId);
  const itemIndex = siblings.indexOf(itemId);
  if (itemIndex === 0) {
    return node.parentId;
  }
  let currentItem = siblings[itemIndex - 1];
  while (instance.isItemExpanded(currentItem) && instance.getNavigableChildrenIds(currentItem).length > 0) {
    currentItem = instance.getNavigableChildrenIds(currentItem).pop();
  }
  return currentItem;
};
export const getNextItem = (instance, itemId) => {
  // If expanded get first child
  if (instance.isItemExpanded(itemId) && instance.getNavigableChildrenIds(itemId).length > 0) {
    return instance.getNavigableChildrenIds(itemId)[0];
  }
  let node = instance.getNode(itemId);
  while (node != null) {
    // Try to get next sibling
    const siblings = instance.getNavigableChildrenIds(node.parentId);
    const nextSibling = siblings[siblings.indexOf(node.id) + 1];
    if (nextSibling) {
      return nextSibling;
    }

    // If the sibling does not exist, go up a level to the parent and try again.
    node = instance.getNode(node.parentId);
  }
  return null;
};
export const getLastItem = instance => {
  let lastItem = instance.getNavigableChildrenIds(null).pop();
  while (instance.isItemExpanded(lastItem)) {
    lastItem = instance.getNavigableChildrenIds(lastItem).pop();
  }
  return lastItem;
};
export const getFirstItem = instance => instance.getNavigableChildrenIds(null)[0];
export const populateInstance = (instance, methods) => {
  Object.assign(instance, methods);
};
export const populatePublicAPI = (publicAPI, methods) => {
  Object.assign(publicAPI, methods);
};